import React from 'react'
import { checkTextTranslation, checkTranslation, getObject, imageAddress } from '../../utils/useful'

class ImageWidget extends React.Component {
    state = {
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {



        if (prevProps.header?.information?.source != this.props.header?.information?.source || this.props.params != prevProps.params) {
            this.init()
        }
    }

    init() {

        let data = this.props.header?.information?.source
        let finalData = data
        // console.log(this.props.header?.information, data)
        // console.log('this.props.header?.information',this.props.params)
        // console.log(data)
        if (data) {


            // console.log(this.props.params)
            if (Array.isArray(this.props.params)) {
                for (let i = 0; i < this.props.params.length; i++) {
                    const param = this.props.params[i];

                    // console.log(param)
                    finalData = this.textVariableReplacer(param?.info, data, param.fields, param.label)
                    // console.log(data)
                }
            }else{
                finalData = this.textVariableReplacer(this.props.fullData, data, this.props.headers, 'Current Record')
            }

            // console.log(finalData)

            this.setState({ data :finalData})
        }
        else if (this.props.header?.information?.customImage) {
            data = this.props.header?.information?.customImage
            this.setState({ data })

        }
    }




    textVariableReplacer = (data, content, fields, preLabel) => {

        // console.log(content)
        if (content && typeof content == 'string') {

            let output = content

            let reg = new RegExp('\{\{(.*?)\}\}', 'g')

            let matches = content.match(reg)

            if (matches) {
                for (let index = 0; index < matches.length; index++) {
                    const match = matches[index];


                    let key = match.replace(/{/g, '').replace(/}/g, '')


                    if (fields) {
                        for (let j = 0; j < fields.length; j++) {
                            const header = fields[j];

                            let label = checkTranslation(header.information?.label)
                            if (preLabel) {
                                label = preLabel + ' - ' + label
                            }

                            // console.log(label)
                            // console.log(key)


                            if (key == label || key == header.key) {


                                let value = getObject(data, header.key)
                                if (value == null) {
                                    value = getObject(data, 'values.' + header.key)
                                }


                                // let nreg = new RegExp(match, 'g')
                                // output = output.replace(nreg, value)
                                output = value

                            }


                        }
                    }
                }
            }

            return output

        }

    }

    // init() {
    //     let data = this.props.data?.source
    //     let output = data
    //     if (typeof data == 'string' && /\{\{(.*?)\}\}/.test(data)) {
    //         let reg = new RegExp('\{\{(.*?)\}\}', 'g')
    //         // console.log("TEST!!")
    //         let matches = data.match(reg)

    //         if (matches && matches.length > 0) {
    //             for (let index = 0; index < matches.length; index++) {
    //                 const match = matches[index];

    //                 // console.log("here!!!")
    //                 let key = match.replace(/{/g, '').replace(/}/g, '')

    //                 // console.log(matches)
    //                 // console.log(key)

    //                 if (this.props.headers) {
    //                     for (let j = 0; j < this.props.headers.length; j++) {
    //                         const header = this.props.headers[j];

    //                         // console.log(header?.key)
    //                         // console.log(header?.type)

    //                         if (((key == header?.information?.label || key == header.key || ('values.' + key) == (header.key))) && header.type == 'ImageInput') {
    //                             let value = getObject(this.props.fullData, header.key)
    //                             // console.log(value)
    //                             // let nreg = new RegExp(match, 'g')
    //                             output = value
    //                         }
    //                     }
    //                 }
    //             }
    //             if (/\{\{(.*?)\}\}/.test(output)) {
    //                 output = null
    //             }
    //         }
    //     } else if (data == '**custom') {
    //         output = this.props.header?.information?.address
    //     }



    //     this.setState({ data: output })

    // }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    renderImage(image, index, margin, local) {
        // let styleInfo = this.props.styleInfo

        // console.log('sss', image)

        if (typeof image == 'string') {
            let reg = new RegExp('\{\{(.*?)\}\}', 'g')

            let matches = image.match(reg)
            if (matches) {

                image = null

            }
        }

        let mimageAddress = imageAddress(image, 'image', 'large')


        // console.log('checkcustomImage', image, mimageAddress)


        let information = this.props.header?.information


        let styleInfo = information?.style
        // if (local) {
        //   mimageAddress = imageAddress(null)
        // }

        // console.log(image)
        // console.log(mimageAddress)

        let aspectRatio
        if (information?.antecedent || information?.consequent) {
            aspectRatio = (Number(information.antecedent) ?? 1) + "/" + (Number(information.consequent) ?? 1)
        }

        // console.log(aspectRatio)
        let objectFit = information?.objectFit ?? 'cover'
        // console.log(styleInfo?.width)

        // let styleWidthInfo = typeof styleInfo?.width == 'object' ? styleInfo?.width?.lg : styleInfo?.width

        // console.log(styleWidthInfo)
        // let width = styleWidthInfo?.width ? (styleWidthInfo?.width + (styleWidthInfo?.widthUnit ?? '%')) : styleWidthInfo
        // if (!width) {
        //     width = '100%'
        // }
        let width = '100%'
        // console.log(information)

        // console.log(width)
        return (
            <img key={index} src={mimageAddress} style={{ aspectRatio, width, borderRadius: styleInfo?.borderRadius ?? 0, objectFit }}  alt=''/>
        )

    }


    render() {


        let styleInfo = this.props.header?.information?.style
        let justifyContent = styleInfo?.align

        // console.log(this.props.header)
        // console.log(this.props.data)
        // let data = this.props.data?.source
        return (

            <div className="text-center d-flex  w-100" style={{ overflow: 'auto', justifyContent: justifyContent ?? 'center' }}>
                {/* {Array.isArray(this.state.data) && this.state.data.map((image, index) => {
                    // console.log(image)
                    return (
                        this.renderImage(image, index, true)
                        // <img key={index} src={imageAddress(image, "mini", 'mini')} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover', marginLeft: 2 }} />
                    )
                })
                } */}

                {Array.isArray(this.state.data) && this.state.data.length > 0 &&
                    // console.log(image)
                    // return (
                    this.renderImage(this.state.data[0], 0, true)
                    // <img key={index} src={imageAddress(image, "mini", 'mini')} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover', marginLeft: 2 }} />


                }


                {(!Array.isArray(this.state.data) || this.state.data.length == 0) && this.state.data && (
                    this.renderImage(this.state.data)
                    // <img src={imageAddress(this.state.data, "mini", "mini")} style={{ width: 30, height: 30, borderRadius: 20, objectFit: 'cover' }} />
                )}

                {!this.state.data && (
                    this.renderImage(null, null, null, true)
                )}

            </div>

            // <div className="w-100 h-100">
            //     <p className="text-small" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{this.props.data}</p>
            // </div>
        )
    }
}

export default ImageWidget;